import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useDispatchTrackEvent, useTealiumEventProperties } from "@grandvisionhq/svc-tealium/events";
import { useWishlistId } from "@grandvisionhq/svc-wishlist";
import WishlistLoader from "../../../../../../components/components/WishlistLoader.js";
import { getWishlistButtonEventInfo, pushWishlistEvent } from "../../../../../../data-layer/data-layer/wishlist.js";
import { useAddToShoppingList } from "../../../../../../hooks/hooks/use-add-to-shopping-list.js";
import { useRemoveFromShoppinglist } from "../../../../../../hooks/hooks/use-remove-from-shopping-list.js";
import { useWishlistAuthState } from "../../../../../../hooks/hooks/use-wishlist-auth-state.js";
import AnonymousWishlistButton from "./AnonymousWishlistButton.js";
import UserWishlistButton from "./UserWishlistButton.js";
const WishlistButtonContainer = ({
  sku,
  productLocation,
  tabIndex
}) => {
  const { localWishlist, clearWishlist } = useWishlistId();
  const { isAuthLoading, isUserLoggedIn } = useWishlistAuthState();
  const dispatchTrackEvent = useDispatchTrackEvent();
  const { getCommonUserProperties } = useTealiumEventProperties();
  const handlePushWishlistEvent = (messageType, interactionType, siteFeature) => {
    pushWishlistEvent({
      siteFeature,
      interactionType,
      messageType,
      item: {
        sku
      }
    });
  };
  const { addToShoppinglist } = useAddToShoppingList({
    isLoggedIn: isUserLoggedIn,
    onCompleted: (data) => {
      if (data.addToShoppinglist.__typename === "AddToShoppinglistSuccessResponse") {
        toast.success("account.wishlist.add.success");
        const { interactionType, siteFeature } = getWishlistButtonEventInfo("add", productLocation);
        handlePushWishlistEvent("item_added", interactionType, siteFeature);
      }
    },
    onError: () => {
      toast.failed("account.wishlist.add.error");
      const { interactionType, siteFeature } = getWishlistButtonEventInfo("add", productLocation);
      handlePushWishlistEvent("error", interactionType, siteFeature);
    }
  });
  const { removeFromShoppinglist, loading: isUpdateLoading } = useRemoveFromShoppinglist({
    onCompleted: (data) => {
      if (data.removeFromShoppinglist.__typename == "RemoveFromShoppinglistSuccessResponse") {
        toast.success("account.wishlist.remove.success");
        const { interactionType, siteFeature } = getWishlistButtonEventInfo(
          "remove",
          productLocation
        );
        handlePushWishlistEvent("item_removed", interactionType, siteFeature);
      }
      if (data.removeFromShoppinglist.__typename === "RemoveFromShoppinglistSuccessResponse" && !data.removeFromShoppinglist.result?.items.length) {
        clearWishlist();
      }
    },
    onError: () => {
      toast.failed("account.wishlist.remove.error");
      const { interactionType, siteFeature } = getWishlistButtonEventInfo("remove", productLocation);
      handlePushWishlistEvent("error", interactionType, siteFeature);
    }
  });
  const handleWishlistSuccessTealium = async () => {
    try {
      const commonUserProperties = await getCommonUserProperties();
      if (!commonUserProperties) return;
      dispatchTrackEvent(
        () => Promise.resolve({
          id: "Event",
          Events_ProdFavAdd: "1",
          ...commonUserProperties
        })
      );
    } catch (error) {
      console.error("Failed to hash email:", error);
    }
  };
  const onWishlistClick = (action, wishlistId, event) => {
    event?.preventDefault();
    if (action === "add") {
      addToShoppinglist([sku], wishlistId).catch((error) => console.log(error));
      handleWishlistSuccessTealium();
    } else {
      removeFromShoppinglist([sku], wishlistId).catch((error) => console.log(error));
    }
  };
  if (isAuthLoading) {
    return /* @__PURE__ */ React.createElement(WishlistLoader, { className: "wishlist-loader__skeleton--button" });
  }
  return !isAuthLoading && isUserLoggedIn ? /* @__PURE__ */ React.createElement(
    UserWishlistButton,
    {
      sku,
      disabled: isAuthLoading || isUpdateLoading,
      isUpdateLoading,
      onWishlistClick,
      tabIndex
    }
  ) : /* @__PURE__ */ React.createElement(
    AnonymousWishlistButton,
    {
      sku,
      disabled: isAuthLoading || isUpdateLoading,
      isUpdateLoading,
      onWishlistClick,
      localWishlistId: localWishlist?.id,
      tabIndex
    }
  );
};
const ConditionalButtonWrapper = (props) => {
  const { isWishlistEnabled } = useFeatureToggles();
  if (isWishlistEnabled) {
    return /* @__PURE__ */ React.createElement(WishlistButtonContainer, { ...props });
  }
  return null;
};
export {
  ConditionalButtonWrapper as default
};
//# sourceMappingURL=WishlistButtonContainer.js.map
